import React, {Component} from 'react';

import {Routes, Route} from 'react-router-dom';
import BuildingContext from '../../contexts/Building';
import EditFloorAndUnit from './pages/edit building/EditFloorAndUnit';
import MainRegister from './pages/Register/MainRegister';
import ProfilePage from './pages/People/ProfilePage';
import SearchAccount from './pages/People/SearchAccount';
import PersonnelProfilePage from './pages/personnel/PersonnelProfilePage';
import SearchPersonnel from './pages/personnel/SearchPersonnel';
import PaymentPage from './pages/paymentPage/PaymentPage';
import EventPage from './pages/EventPage/EventPage';
import RequestPage from './pages/RequestPage/RequestPage';
import Contacts from './pages/contacts/contacts';
import PaymentHistory from './pages/PaymentHistory/PaymentHistory';
import RequestPageManager from "./pages/RequestPage/RequestPageManager";
import CallHistory from './pages/callHistory/callHistory';
import TrelloPage from "./pages/TrelloPage/TrelloPage";
import Inventory from './pages/inventory/inventory';
import PersonnelRegister from "./pages/PersonnelRegister/PersonnelRegister";
import PresenceAbsence from "./pages/PresenceAbsence/presenceAbsence";
import PresenceAbsenceRoomPerson from './pages/PresenceAbsence/PresenceAbsenceRoomPerson';
import CleaningArchive from './pages/PresenceAbsence/CleaningArchive';
import RoomLog from "./pages/Inventory and capacity/RoomLog";
import Setting from "./pages/Setting/Setting";
import Log from "./pages/log/log";
import Floor from "./pages/New IAC/Floor";
import EditFloor from "./pages/Edit New IAC/EditFloor";
import Unit from "./pages/New IAC/Unit";
import EditUnit from "./pages/Edit New IAC/EditUnit";
import Room from "./pages/New IAC/Room";
import EditRoom from "./pages/Edit New IAC/EditRoom";
import Bed from "./pages/New IAC/Bed";
import EditBed from "./pages/Edit New IAC/EditBed";
import DashboardStats from "./pages/DashboardStats";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

class MainPage extends Component {
    personnelSubmitRef = null;
    state = {

        typeofResident: 'constant',
        unitNumber: "",
        unitIdPA: "",
        unitNumberPA: "",
        unitId: "",
        personId: "",
        charId: "",

        valueOfDates: {
            constantResident: {
                birthDate: '',
                startDate: '',
                endDate: '',
                depositReturnDate: '',

            },
            familyGuest: {
                birthDate: '',
                startDate: '',
                endDate: '',
                paymentDate: '',
                depositReturnDate: '',

            },
            otherGuest: {
                birthDate: '',
                startDate: '',
                endDate: '',
                paymentDate: '',
                depositReturnDate: '',
            },

            personnel: {
                birthDate: '',
                startDate: '',
                endDate: '',

            }
        },

        fields: {
            personnelFields: {
                id: '',
                firstName: '',
                lastName: '',
                fatherName: '',
                nationalCode: '',
                placeOfIssue: '',
                certificateNumber: '',
                phoneNumber: '',
                address: '',
                telephoneNumber: '',
                emergencyNumber: '',
                birthPlace: '',
                birthDate: '', //
                education: '',
                postalCode: '',
                email: '',
                nationality: '',
                maritalStatus: 'single', // default value
                religion: 'islam', // default value
                subReligion: '',
                healthyStatus: '',
                health: 'false',
                alias: '',
                university: '', //
                major: '',
                spouseFullName: '',
                spouseJob: '', //
                bankAccountOwnerName: '',
                bankAccountShabaNumber: '',
                fullName: '',//
                parentType: 'Personnel',
                gender: 'male',
                startDate: '',
                endDate: '',
                type: '',
                profileId: '',
            },

            personnelUploadPage: [],

            //MAIN REGISTER
            //############################################################################## first page
            // ----------------------- <CInformationPage /> information
            constantInformationPage: {
                firstName: '',
                lastName: '',
                alias: '',
                nationalCode: '',
                certificateNumber: '',
                placeOfIssue: '',
                birthDate: '',
                nationality: '',
                fatherName: '',
                religion: 'islam',
                subReligion: '',
                university: '',
                education: '',
                studentNumber: '',
                fatherJob: '',
                maritalStatus: 'single', // default value (first option)
                spouseFullName: '',
                spouseJob: '',
                parentType: 'Person',
                personType : "constant",
                health: 'false', // default value (first option)
                healthyStatus: '',
            },

            // ----------------------- <FGInformationPage /> information
            familyGuestInformation: { // مهمان بستگان درجه یک -- صفحه مشخصات اولیه
                firstName: '',
                lastName: '',
                nationalCode: '',
                certificateNumber: '',
                placeOfIssue: '',
                birthDate: '',
                startDate: '',
                endDate: '',
                paymentDate: '',
                depositReturnDate: '',
                parentType: 'Person',
                personType : "familyGuest",
                rentPaymentAmount: '',
                depositPaymentAmount: '',
                discountPaymentAmount: '',
                relationshipWithResident: 'mother', // default value (first option)
            },

            // ----------------------- <OGInformationPage /> information
            otherGuestInformation: {
                firstName: '',
                lastName: '',
                nationalCode: '',
                certificateNumber: '',
                placeOfIssue: '',
                startDate: '',
                endDate: '',
                paymentDate: '',
                parentType: 'Person',
                personType : "otherGuest",
                rentPaymentAmount: '',
                depositPaymentAmount: '',
                discountPaymentAmount: '',
                birthDate: '',
                depositReturnDate: '',
            },

            //##############################################################################

            //############################################################################## second page
            // ----------------------- <CInformationFurtherPage /> information
            constantInformationFurther: {
                address: '',
                telephoneNumber: '',
                phoneNumber: '',
                startDate: '',
                endDate: '',
                depositReturnDate: '',
                parentAddress: '',
            },

            // ----------------------- <FGInformationFurtherPage /> information
            familyGuestInformationFurther: {
                address: '',
                telephoneNumber: '',
                phoneNumber: '',
            },
            // ----------------------- <OGInformationFurtherPage /> information
            otherGuestInformationFurther: {
                address: '',
                telephoneNumber: '',
                phoneNumber: '',
            },
            //##############################################################################


            //############################################################################## third page
            // ----------------------- <CInformationFamilyPage /> information
            constantInformationFamily: {
                firstPersonFullName: '',
                firstPersonPhoneNumber: '',
                firstPersonFatherName: '',
                firstPersonRelationshipWithResident: 'father', // default value (first option)

                secondPersonFullName: '',
                secondPersonPhoneNumber: '',
                secondPersonFatherName: '',
                secondPersonRelationshipWithResident: 'father', // default value (first option)

                thirdPersonFullName: '',
                thirdPersonPhoneNumber: '',
                thirdPersonFatherName: '',
                thirdPersonRelationshipWithResident: 'father', // default value (first option)
            },
            // ----------------------- <FGIInformationFamilyPage /> information
            familyGuestInformationFamily: {
                hostId:''
            },
            // ----------------------- <OGIInformationFamilyPage /> information
            otherGuestInformationFamily: {
                hostId:''
            },
            //##############################################################################

            //############################################################################## fourth page
            constantUploadPage: [],

            familyGuestUploadPage: [],

            otherGuestUploadPage: [],
            //##############################################################################

            slider: []
        },
        errors: {
            required: 'این فیلد الزامی است!',
            numberRequired: 'عدد وارد کنید!',
            homeTelephoneReg: 'شماره تلفن ثابت ۱۱ رقمی با کد وارد شود! ',
            telephoneRegex: 'شماره تلفن همراه وارد کنید! (۰۹۱۲۳۴۵۶۷۸۹)',
            emailRegex: 'ایمیل وارد کنید!',
        },

        specificValidations: {

            personnelFieldsValidation: {
                //first page
                firstName_requiredReg: '',
                lastName_requiredReg: '',
                fatherName_requiredReg: '',
                nationalCode_requiredReg: '',
                placeOfIssue_requiredReg: '',
                certificateNumber_requiredReg: '',
                phoneNumber_requiredReg: '',
                address_requiredReg: '',
                telephoneNumber_requiredReg: '',
                emergencyNumber_requiredReg: '',
                birthPlace_requiredReg: '',
                birthDate_requiredReg: '',
                education_requiredReg: '',
                postalCode_requiredReg: '',
                email_requiredReg: '',
                nationality_requiredReg: '',
                maritalStatus_requiredReg: '',
                religion_requiredReg: '',
                nationalCode_numberReg: '',
                certificateNumber_numberReg: '',
                postalCode_numberReg: '',
                phoneNumber_phoneNumberReg: '',
                telephoneNumber_homeTelephoneReg: '',
                emergencyNumber_MobileOrHomeTelephoneReg: '',
                email_emailReg: '',
                healthyStatus_requiredReg: '',
                type_requiredReg: '',

                //second page
                major_requiredReg: '',
                spouseFullName_requiredReg: '',
                bankAccountOwnerName_requiredReg: '',
                bankAccountShabaNumber_requiredReg: '',
                fullName_requiredReg: '',
                parentType_requiredReg: '',
                parentId_requiredReg: '',
                gender_requiredReg: '',
                bankAccountShabaNumber_numberReg: '',
            },

            //MAIN REGISTER

            //############################################################################## first page

            // ----------------------- <CInformationPage /> information validations
            constantInformationPageValidation: {
                firstName_requiredReg: '',
                lastName_requiredReg: '',
                nationalCode_requiredReg: '',
                nationalCode_numberReg: '',
                certificateNumber_requiredReg: '',
                certificateNumber_numberReg: '',
                placeOfIssue_requiredReg: '',
                // placeOfIssue_dateReg: '',
                birthDate_requiredReg: '',
                nationality_requiredReg: '',
                fatherName_requiredReg: '',
                studentNumber_numberReg: '',
                spouseFullName_requiredReg: '',
                healthyStatus_requiredReg: '',
            },

            // ----------------------- <FGInformationPage /> information validation
            familyGuestInformationValidation: {
                firstName_requiredReg: '',
                lastName_requiredReg: '',
                nationalCode_requiredReg: '',
                nationalCode_numberReg: '',
                certificateNumber_requiredReg: '',
                certificateNumber_numberReg: '',
                startDate_requiredReg: true,
                endDate_requiredReg: true,
                paymentDate_requiredReg: '',
                birthDate_requiredReg: '',
                depositReturnDate_requiredReg: true,
                rentPaymentAmount_numberReg: '',
                depositPaymentAmount_numberReg: '',
                discountPaymentAmount_numberReg: '',
                phoneNumber_telephoneReg: '',
            },

            // ----------------------- <OGInformationPage /> information validations
            otherGuestInformationValidation: {
                firstName_requiredReg: '',
                lastName_requiredReg: '',
                nationalCode_requiredReg: '',
                nationalCode_numberReg: '',
                certificateNumber_requiredReg: '',
                certificateNumber_numberReg: '',
                startDate_requiredReg: true,
                // startDate_dateReg: '',
                endDate_requiredReg: true,
                birthDate_requiredReg: '',
                depositReturnDate_requiredReg: true,
                paymentDate_requiredReg: '',
                // startDate_dateReg: '',
                // paymentDate_dateReg: '',
                rentPaymentAmount_numberReg: '',
                depositPaymentAmount_numberReg: '',
                discountPaymentAmount_numberReg: '',
                // birthDate_dateReg: '',
            },

            //##############################################################################

            //############################################################################## second page
            // ----------------------- <CInformationFurtherPage /> information validations
            constantInformationFurtherValidation: {
                address_requiredReg: '',
                telephoneNumber_requiredReg: '',
                telephoneNumber_homeTelephoneReg: '',
                phoneNumber_requiredReg: '',
                phoneNumber_telephoneReg: '',
                startDate_requiredReg: '',
                endDate_requiredReg: '',
                depositReturnDate_requiredReg: true,
            },

            // ----------------------- <FGInformationFurtherPage /> information validations
            familyGuestInformationFurtherValidation: {
                address_requiredReg: '',
                telephoneNumber_requiredReg: '',
                telephoneNumber_homeTelephoneReg: '',
                phoneNumber_requiredReg: '',
                phoneNumber_telephoneReg: '',
            },
            // ----------------------- <OGInformationFurtherPage /> information validations
            otherGuestInformationFurtherValidation: {
                address_requiredReg: '',
                telephoneNumber_requiredReg: '',
                telephoneNumber_homeTelephoneReg: '',
                phoneNumber_requiredReg: '',
                phoneNumber_telephoneReg: '',
            },
            //##############################################################################


            //############################################################################## third page
            // ----------------------- <CInformationFamilyPage /> information validations
            constantInformationFamilyValidation: {
                firstPersonFullName_requiredReg: '',
                firstPersonPhoneNumber_requiredReg: '',
                firstPersonPhoneNumber_telephoneReg: '',

                secondPersonFullName_requiredReg: '',
                secondPersonPhoneNumber_requiredReg: '',
                secondPersonPhoneNumber_telephoneReg: '',

                thirdPersonPhoneNumber_telephoneReg: true,
            },
            // ----------------------- <FGIInformationFamilyPage /> information validations
            familyGuestInformationFamilyValidation: {
                hostId_requiredReg: '',
            },
            // ----------------------- <OGIInformationFamilyPage /> information validations
            otherGuestInformationFamilyValidation: {

            },
            //##############################################################################
        },
    }

    render() {
        return (
            <>
                <div className='d-flex flex-column pt-4 px-3'>
                    <BuildingContext.Provider value={{
                        slider: this.state.fields.slider,
                        personnelFields: this.state.fields.personnelFields,
                        personnelFieldsValidation: this.state.specificValidations.personnelFieldsValidation,
                        unitId: this.state.unitId,
                        unitIdPA: this.state.unitIdPA,
                        personId: this.state.personId,
                        charId: this.state.charId,
                        typeofResident: this.state.typeofResident,
                        unitNumber: this.state.unitNumber,
                        unitNumberPA: this.state.unitNumberPA,
                        fields: this.state.fields,
                        errors: this.state.errors,
                        valueOfDates: this.state.valueOfDates,
                        constantInformationPage: this.state.fields.constantInformationPage,
                        constantInformationPageValidation: this.state.specificValidations.constantInformationPageValidation,

                        familyGuestInformation: this.state.fields.familyGuestInformation,
                        familyGuestInformationValidation: this.state.specificValidations.familyGuestInformationValidation,

                        otherGuestInformation: this.state.fields.otherGuestInformation,
                        otherGuestInformationValidation: this.state.specificValidations.otherGuestInformationValidation,

                        constantInformationFurther: this.state.fields.constantInformationFurther,
                        constantInformationFurtherValidation: this.state.specificValidations.constantInformationFurtherValidation,

                        familyGuestInformationFurther: this.state.fields.familyGuestInformationFurther,
                        familyGuestInformationFurtherValidation: this.state.specificValidations.familyGuestInformationFurtherValidation,

                        otherGuestInformationFurther: this.state.fields.otherGuestInformationFurther,
                        otherGuestInformationFurtherValidation: this.state.specificValidations.otherGuestInformationFurtherValidation,

                        constantInformationFamily: this.state.fields.constantInformationFamily,
                        constantInformationFamilyValidation: this.state.specificValidations.constantInformationFamilyValidation,

                        familyGuestInformationFamily: this.state.fields.familyGuestInformationFamily,
                        familyGuestInformationFamilyValidation: this.state.specificValidations.familyGuestInformationFamilyValidation,

                        otherGuestInformationFamily: this.state.fields.otherGuestInformationFamily,
                        otherGuestInformationFamilyValidation: this.state.specificValidations.otherGuestInformationFamilyValidation,

                        specificValidations: this.state.specificValidations,

                        constantUploadPage: this.state.fields.constantUploadPage, // UploadPage
                        familyGuestUploadPage: this.state.fields.familyGuestUploadPage, // UploadPage
                        otherGuestUploadPage: this.state.fields.otherGuestUploadPage, // UploadPage
                        personnelUploadPage: this.state.fields.personnelUploadPage,

                        handleTypeofResident: this.handleTypeofResident,
                        handleUnitNumber: this.handleUnitNumber,
                        handleUnitNumberPA: this.handleUnitNumberPA,
                        handlePersonId: this.handlePersonId,
                        handleFields: this.handleFields,
                        handleDates: this.handleDates,
                        handleValueOfDate: this.handleValueOfDate,
                        handleValidations: this.handleValidations,
                        handleSpecificValidations: this.handleSpecificValidations,
                        handleUploadedFile: this.handleUploadedFile,
                        handleDeleteUploadedFile: this.handleDeleteUploadedFile,
                        handleReset: this.handleReset,
                        handleImageSlider: this.handleImageSlider,
                        handleResetSlider: this.handleResetSlider,
                        handleResetPersonnelSpouseJobAndFullName: this.handleResetPersonnelSpouseJobAndFullName,
                        registerPersonnelSubmit: this.registerPersonnelSubmit,
                        personnelSubmitHandler: this.invokePersonnelSubmit,
                    }}
                    >
                        <Routes>
                            <Route path="/" element={(<DashboardStats/>)}/>
                            <Route path="/home" element={(<DashboardStats/>)}/>
                            {/*<Route path="/" element={(<Home/>)}/>*/}
                            {/*<Route path="/booking" element={(<FloorAndUnit/>)}/>*/}
                            {/*<Route path="/booking/edit-floor-and-unit" element={(<EditFloorAndUnit/>)}/>*/}
                            {/*<Route path="/RoomAndBed" element={(<RoomAndBed/>)}/>*/}
                            {/*<Route path='/RoomAndBed/edit-room-and-bed' element={(<EditRoomAndBed/>)}/>*/}
                            <Route path="/people" element={(<SearchAccount/>)}/>
                            <Route path="/people/*" element={(<ProfilePage/>)}/>
                            <Route path="/personnel" element={(<SearchPersonnel/>)}/>
                            <Route path="/personnel/*" element={(<PersonnelProfilePage/>)}/>
                            <Route path='/payment' element={(<PaymentPage/>)}/>
                            <Route path='/contacts' element={(<Contacts/>)}/>
                            <Route path='/CallHistory' element={(<CallHistory/>)}/>
                            <Route path='/Inventory' element={(<Inventory/>)}/>
                            <Route path="/Register" element={(<MainRegister/>)}/>
                            <Route path="/edit" element={(<EditFloorAndUnit/>)}/>
                            <Route path="/Calender" element={(<EventPage/>)}/>
                            <Route path="/Request" element={(<RequestPage/>)}/>
                            <Route path="/PersonnelRegister" element={(<PersonnelRegister/>)}/>
                            <Route path="/Request-manager" element={(<RequestPageManager/>)}/>
                            <Route path="/Request" element={(<RequestPage/>)}/>
                            {/*<Route path="/camera-history" element={(<CameraHistoryPage/>)}/>*/}
                            <Route path="/PaymentHistory" element={(<PaymentHistory/>)}/>
                            <Route path="/taskManagement" element={(<TrelloPage/>)}/>
                            <Route path="/PresenceAbsence" element={(<PresenceAbsence/>)}/>
                            <Route path="/PresenceAbsencePage2" element={(<PresenceAbsenceRoomPerson/>)}/>
                            <Route path="/CleaningArchive" element={(<CleaningArchive/>)}/>
                            <Route path="/setting" element={(<Setting/>)}/>
                            <Route path="/log" element={(<Log/>)}/>
                            <Route path="/booking/room_log" element={(<RoomLog/>)}/>

                            <Route path="/booking/floor" element={(<Floor/>)}/>
                            <Route path="/booking/edit-floor" element={(<EditFloor/>)}/>
                            <Route path="/booking/floor/*" element={(<Unit/>)}/>
                            <Route path="/booking/edit-unit/*" element={(<EditUnit/>)}/>

                            <Route path="/booking/floor/unit/*" element={(<Room/>)}/>
                            <Route path="/booking/floor/unit/room/*" element={(<Bed/>)}/>
                            <Route path="/booking/edit-room/*" element={(<EditRoom/>)}/>
                            <Route path="/booking/edit-bed/*" element={(<EditBed/>)}/>

                        </Routes>
                    </BuildingContext.Provider>
                </div>
            </>
        );
    }

    handleReset = () => {
        let resetDateValues = {
            constantResident: {
                birthDate: '',
                startDate: '',
                endDate: '',
                depositReturnDate: '',

            },
            familyGuest: {
                birthDate: '',
                startDate: '',
                endDate: '',
                paymentDate: '',
                depositReturnDate: '',

            },
            otherGuest: {
                birthDate: '',
                startDate: '',
                endDate: '',
                paymentDate: '',
                depositReturnDate: '',
            },
            personnel: {
                birthDate: '',
                startDate: '',
                endDate: '',

            },

            // ...this.state.valueOfDates.personnel,
        };

        let resetFields = {
            // ...this.state.fields.personnelFields,
            personnelFields: {
                id: '',
                firstName: '',
                lastName: '',
                fatherName: '',
                nationalCode: '',
                placeOfIssue: '',
                certificateNumber: '',
                phoneNumber: '',
                address: '',
                telephoneNumber: '',
                emergencyNumber: '',
                birthPlace: '',
                birthDate: '', //
                education: '',
                postalCode: '',
                email: '',
                nationality: '',
                maritalStatus: 'single', // default value
                religion: 'islam', // default value
                subReligion: '',
                healthyStatus: '',
                health: 'false',
                alias: '',
                university: '', //
                major: '',
                spouseFullName: '',
                spouseJob: '', //
                bankAccountOwnerName: '',
                bankAccountShabaNumber: '',
                fullName: '',//
                parentType: 'Personnel',
                gender: 'male',
                startDate: '',
                endDate: '',
                type: '',
                profileId: '',
            },
            //MAIN REGISTER
            //############################################################################## first page
            // ----------------------- <CInformationPage /> information
            constantInformationPage: {
                firstName: '',
                lastName: '',
                alias: '',
                nationalCode: '',
                certificateNumber: '',
                placeOfIssue: '',
                birthDate: '',
                nationality: '',
                fatherName: '',
                religion: 'islam',
                subReligion: '',
                university: '',
                education: '',
                studentNumber: '',
                fatherJob: '',
                maritalStatus: 'single', // default value (first option)
                spouseFullName: '',
                spouseJob: '',
                health: 'false', // default value (first option)
                healthyStatus: '',
            },

            // ----------------------- <FGInformationPage /> information
            familyGuestInformation: { // مهمان بستگان درجه یک -- صفحه مشخصات اولیه
                firstName: '',
                lastName: '',
                nationalCode: '',
                certificateNumber: '',
                placeOfIssue: '',
                birthDate: '',
                startDate: '',
                endDate: '',
                paymentDate: '',
                depositReturnDate: '',
                rentPaymentAmount: '',
                depositPaymentAmount: '',
                discountPaymentAmount: '',
                relationshipWithResident: 'mother', // default value (first option)
            },

            // ----------------------- <OGInformationPage /> information
            otherGuestInformation: {
                firstName: '',
                lastName: '',
                nationalCode: '',
                certificateNumber: '',
                placeOfIssue: '',
                startDate: '',
                endDate: '',
                paymentDate: '',
                rentPaymentAmount: '',
                depositPaymentAmount: '',
                discountPaymentAmount: '',
                birthDate: '',
                depositReturnDate: '',
            },

            //##############################################################################

            //############################################################################## second page
            // ----------------------- <CInformationFurtherPage /> information
            constantInformationFurther: {
                address: '',
                telephoneNumber: '',
                phoneNumber: '',
                startDate: '',
                endDate: '',
                depositReturnDate: '',
                parentAddress: '',
            },

            // ----------------------- <FGInformationFurtherPage /> information
            familyGuestInformationFurther: {
                address: '',
                telephoneNumber: '',
                phoneNumber: '',
            },
            // ----------------------- <OGInformationFurtherPage /> information
            otherGuestInformationFurther: {
                address: '',
                telephoneNumber: '',
                phoneNumber: '',
            },
            //##############################################################################


            //############################################################################## third page
            // ----------------------- <CInformationFamilyPage /> information
            constantInformationFamily: {
                firstPersonFullName: '',
                firstPersonPhoneNumber: '',
                firstPersonFatherName: '',
                firstPersonRelationshipWithResident: 'father', // default value (first option)

                secondPersonFullName: '',
                secondPersonPhoneNumber: '',
                secondPersonFatherName: '',
                secondPersonRelationshipWithResident: 'father', // default value (first option)
            },
            // ----------------------- <FGIInformationFamilyPage /> information
            familyGuestInformationFamily: {
                hostId:''
            },
            // ----------------------- <OGIInformationFamilyPage /> information
            otherGuestInformationFamily: {
                hostId:''
            },
            //##############################################################################

            //############################################################################## fourth page
            constantUploadPage: [],

            familyGuestUploadPage: [],

            otherGuestUploadPage: [],
            //##############################################################################
        };

        this.setState({valueOfDates : resetDateValues});

        this.setState({fields : resetFields});
    }

    handleUploadedFile = (residentTypeString, name, fileId) => {
        let updatedFiles = {...this.state.fields};
        let tmp = {
            name: name,
            fileId: fileId,
        }
        updatedFiles[residentTypeString].push(tmp);
        this.setState({fields: updatedFiles});
    }

    handleDeleteUploadedFile = (residentTypeString, fileId) => {
        let updatedFiles = {...this.state.fields};
        updatedFiles[residentTypeString] = updatedFiles[residentTypeString].filter(f => f.fileId !== fileId);
        this.setState({fields: updatedFiles});
    }

    handleTypeofResident = (type) => {
        this.setState({typeofResident: type});
    }

    handleUnitNumber = (unitNumber, unitId) => {
        this.setState({unitNumber: unitNumber});
        this.setState({unitId: unitId});
    }
    handleUnitNumberPA = (unitNumber, unitId) => {
        this.setState({unitNumberPA: unitNumber});
        this.setState({unitIdPA: unitId});
    }
    handlePersonId = (personId, charId) => {
        this.setState({personId: personId, charId: charId});
    }

    handleFields = (value, residentType, field) => {
        let newFields = {...this.state.fields};
        newFields[residentType][field] = value
        this.setState({fields: newFields});
    }

    handleDates = (value, residentType, field) => {
        this.setState((prev) => {
            const newFields = {...prev.fields};
            newFields[residentType] = {...newFields[residentType], [field]: value};

            let newValueOfDates = prev.valueOfDates;
            const isGuestInfo = residentType === 'otherGuestInformation'
                || residentType === 'familyGuestInformation';
            const isConstantFurther = residentType === 'constantInformationFurther';

            if (field === 'endDate' && (isGuestInfo || isConstantFurther) && value) {
                try {
                    // Constant resident: +45 days; guests: +2 days
                    const daysToAdd = isConstantFurther ? 45 : 2;
                    // Clone before add — DateObject.add mutates in place
                    const depositObj = new DateObject({
                        date: String(value).split(' ')[0],
                        format: 'YYYY/MM/DD',
                        calendar: persian,
                        locale: persian_fa,
                    }).add(daysToAdd, 'day');
                    const deposit = depositObj.format('YYYY/MM/DD');
                    newFields[residentType] = {
                        ...newFields[residentType],
                        depositReturnDate: deposit,
                    };
                    let dateKey = 'constantResident';
                    if (residentType === 'otherGuestInformation') {
                        dateKey = 'otherGuest';
                    } else if (residentType === 'familyGuestInformation') {
                        dateKey = 'familyGuest';
                    }
                    newValueOfDates = {...prev.valueOfDates};
                    newValueOfDates[dateKey] = {
                        ...newValueOfDates[dateKey],
                        depositReturnDate: depositObj,
                    };
                } catch (e) {
                    // keep endDate only
                }
            }

            return {fields: newFields, valueOfDates: newValueOfDates};
        });
    }

    handleValueOfDate = (value, residentType, field) => {
        this.setState((prev) => {
            const newValueOfDates = {...prev.valueOfDates};
            newValueOfDates[residentType] = {
                ...newValueOfDates[residentType],
                [field]: value,
            };
            return {valueOfDates: newValueOfDates};
        });
    }

    handleValidations = (fields, names) => {
        let newValidations = {...this.state.validations};
        for (let i = 0; i < names.length; i++) {
            newValidations[names[i]] = fields[i];
        }
        // newValidations[name] = field;
        this.setState({validations: newValidations});

        // console.log(newValidations)
    }

    handleSpecificValidations = (fields, names, residentType) => {
        let newSpecificValidations = {...this.state.specificValidations};
        for (let i = 0; i < names.length; i++) {
            newSpecificValidations[residentType][names[i]] = fields[i];
        }
        // newValidations[name] = field;

        this.setState({specificValidations: newSpecificValidations});
        console.log(this.state.fields)
        // console.log(this.state.fields.otherGuestInformationFurther)
    }

    handleImageSlider = (name, id) => {
        let updatedState = {...this.state};

        if (!updatedState.fields.slider.includes({
            name: name,
            fileId: id
        })) {
            updatedState.fields.slider.push({
                name: name,
                fileId: id
            })
        }

        this.setState({updatedState})

    }

    handleResetSlider = () => {
        // console.log(this.state.fields.slider)
        let updatedState = {...this.state};

        updatedState.fields.slider = []

        this.setState({updatedState})
    }

    registerPersonnelSubmit = (fn) => {
        this.personnelSubmitRef = fn;
    }

    invokePersonnelSubmit = () => {
        if (this.personnelSubmitRef) {
            this.personnelSubmitRef();
        }
    }

    handleResetPersonnelSpouseJobAndFullName = () => {
        let updatedValues = {...this.state.fields};

        updatedValues.personnelFields.spouseFullName = '';
        updatedValues.personnelFields.spouseJob = '';

        this.setState({fields: updatedValues});
    }
}

export default MainPage;